// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__WNCJI","error":"styles_error__200ji","user":"styles_user__3sN_p","signIn":"styles_signIn__2fn9l"};